import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';
import { Router } from '@angular/router';
import { Data } from "./data";

@Component({
    selector: 'app-couponcode',
    templateUrl: './companyinfo.component.html',
  providers: [ SharedService,PopupSegmentComponent]
 
})
export class CompanyInfoComponent implements OnInit {
isAllCompaniesAllowed : any;
data=[];
i=1;
page : number =1;
itemsTotalAdv : number =0;
objLoaderStatus: boolean = false;
errormessage = '';
charFlag :boolean = false;
userId : number;
searchmessage = "";
companies =[];
coupon =[];
companyFlag : boolean;
user = [];
companiesSelected =[];
branchFlag : any;
companySelected = {"id":'',"name":''};
branchData = [{"branchCompanyModel":{"branchFlag":false,"userBaseModel":{}},"userBaseModel":{}}];
companyData = [];
branches =[];
radioselected : any;
    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService,
    private PopupSegment: PopupSegmentComponent, 
    private dialogService:DialogService,
    private router: Router,
    private dataCompany: Data,
) {

    
    }

    ngOnInit() {
      var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 
       this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
this.localstorage.setStorage("country",'');
 if(this.dataCompany.storage && this.dataCompany.storage.isAllCompaniesAllowed){
this.isAllCompaniesAllowed = this.dataCompany.storage.isAllCompaniesAllowed;
 }
  
  if(this.dataCompany.storage && this.dataCompany.storage.radioselected == false){
this.radioselected = this.dataCompany.storage.radioselected;
 }

  if(this.dataCompany.storage && this.dataCompany.storage.companyData){
this.companyData = this.dataCompany.storage.companyData;
 }

  if(this.dataCompany.storage && this.dataCompany.storage.branchData){
this.branchData = this.dataCompany.storage.branchData;
 }

 console.log(this.companyData);
  console.log(this.branchData);

localStorage.setItem("user",JSON.stringify(this.user));
       var i=0;
       var j=0;
       if(this.isAllCompaniesAllowed == true){
         var token = this.localstorage.getStorage("token");
         this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("master/getAllCompanies", null, token).subscribe((result) => {
if(result.data){
    this.data = result.data;
           this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
  this.loaderService.displayLoader(false);
             console.log(this.data);

}
     });
       }
     else{
       this.data = this.companyData;
       if(this.branchData !== null && this.branchData !== undefined){
       for(i=0;i<this.branchData.length;i++){
         this.branchData[i].branchCompanyModel.branchFlag = true;
         this.branchData[i].branchCompanyModel.userBaseModel = this.branchData[i].userBaseModel;
       this.data.push(this.branchData[i].branchCompanyModel);       
      }
       }
       this.itemsTotalAdv =this.data.length;

     console.log(this.data); 
      }
 
    }

nextCompany(event){
   this.itemsTotalAdv =0;
    var j=0;
    var i=0;
    this.page = event;
    var token = this.localstorage.getStorage("token");
    this.errormessage ="";
    this.searchmessage = "";
         if(this.isAllCompaniesAllowed == true){

          this.loaderService.displayLoader(true);

  this.shareService.CallDatawithToken("master/getAllCompanies?currentPage="+event, null, token).subscribe((result) => {
    if(result.data){
      if(result.data.length>0){
    this.data = result.data;
        this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
      }
       else{
        this.searchmessage = "No records found";
      }
    this.loaderService.displayLoader(false);

}
  
         });
        }
        else{
       this.data = this.companyData;
       if(this.branchData !== null && this.branchData !== undefined){
       for(i=0;i<this.branchData.length;i++){
         this.branchData[i].branchCompanyModel.branchFlag = true;
         this.branchData[i].branchCompanyModel.userBaseModel = this.branchData[i].userBaseModel;
       this.data.push(this.branchData[i].branchCompanyModel);       
      }
       }
       this.itemsTotalAdv =this.data.length;

     console.log(this.data); 
      
     }  
  
    return event; 
    
}

getBranchesInfo(id,name){
this.dataCompany.storage = {
   
    "radioselected": true,
   "isAllCompaniesAllowed": this.isAllCompaniesAllowed,
   "companyData":this.companyData,
   "branchData":this.branchData,
   "name":name,

  }
       this.router.navigate(['/admin/couponCodes/branchInfo']);

}

}



// WEBPACK FOOTER //
// ./src/app/admin/layout/couponCode/companyinfo.component.ts